<span class="error help-block text-danger text-center f-11">{{
  utilService.missedErrors
}}</span>
